import React from "react";
import InnerCard from "../../../InnerServicePage/InnerCard/InnerCard";

const HairColorService = () => {
  return (
    <div className="hairSpaServiceContainer">
      <div className="hairSpaServiceContent">
        <InnerCard
          head="Milk Shake Argan Cocktail Service"
          para="Treat your hair to the nourishing benefits of argan oil with Milkshake's Whipped Cream. Restore your hair's health and enhance its lustrous shine."
        />
        <InnerCard
          head="Milk Shake Direct Color Cocktail Service"
          para="Enhance your hair with vibrancy and depth while treating it with care using our direct color technique with Milkshake’s hair products."
        />
        <InnerCard
          head="Creative Hair Colour"
          para="Allow our trained stylists to create a personalized and innovative color that perfectly complements your individual style."
        />
        <InnerCard
          head="Creative colour flashes"
          para="Enhance your appearance with artistic flashes of color strategically placed for a unique and bold statement."
        />
        <InnerCard
          head="Colour toning using RUSK COLOUR"
          para="Attain your desired shade and enrich the color of your hair with our professional RUSK COLOR treatments."
        />
        <InnerCard
          head="Global Pre lightening"
          para="Get ready for your new look with an all-over hair brightening service, setting the stage for your chosen global hair color or highlights."
        />
        <InnerCard
          head="3D colour service/shine lines"
          para="Enhance your hair with strategically placed color accents that add gorgeous dimension, depth, and shine."
        />
        <InnerCard
          head="Highlights/streaks"
          para="Elevate your natural beauty with carefully placed lighter strands or streaks for added dimension."
        />
        <InnerCard
          head="Global hair colour"
          para="Embrace a complete transformation or refresh your current look with our global hair colors by Wella."
        />
        <InnerCard
          head="Additional Treatment"
          para="Customized services crafted to meet your specific hair needs, ensuring your locks receive the care they deserve."
        />
      </div>
    </div>
  );
};

export default HairColorService;
